import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface BloodBankGenParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface BloodBankGen {
    id?: any;
   
    typeCode?:string;
    typeKeyValue?:string;
    typeDesc?:string;
    
    parameters?: BloodBankGenParameter[];
    links?: any;
}


export abstract class BloodBankGenData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<BloodBankGen[]>;
    abstract create(url: string, data: BloodBankGen): Observable<BloodBankGen[]>;
    abstract update(url: string, data: BloodBankGen): Observable<BloodBankGen>;
    abstract delete(url: string): Observable<any>;
}
